export default "__VITE_ASSET__A1cwq2gl__"